import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Container,
  IconButton,
} from "@mui/material";
import { ConsultantuseAuth } from "../../security/ConsultantUseAuth";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

import { Consultant_Get_One_From_MongoDB } from "../../api/Consultant_Get_One_From_MongoDB";
import GetClientAddress from "../../../functions/GetClientAddress";
import { Get_One_From_MongoDB } from "../../api/Get_One_From_MongoDB";
import { Consultant_Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Consultant_Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";

import { Get_All_From_MongoDB_With_Search_Prop_In_Array } from "../../api/Get_All_From_MongoDB_With_Search_Prop_In_Array";
import OurTeam from "./components/OurTeam";
import SummerPricing from "./components/SummerPricing";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import Stats from "./components/Stats";
import Header from "./components/Header";
import SpacesLeft from "./components/SpacesLeft";

const HomePageConsultant = () => {
  const { logoutConsultant } = ConsultantuseAuth();

  //------------------------------------------Width Stuff

  const [screenWidth, setscreenWidth] = useState(
    window.innerWidth <= 1200 ? "Small" : "Big"
  );

  useEffect(() => {
    const handleResize = () => {
      setscreenWidth(window.innerWidth <= 1200 ? "Small" : "Big");
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  //----------------------------------------------------------
  function handleOpenOfficialWebsite() {
    window.open(`https://investin.org`);
  }
  function handleOpenBespokeForm() {
    window.open(
      `${GetClientAddress()}Public/RegistrationForm/${localStorage.getItem(
        "Consultant_id"
      )}`
    );
  }
  function handleOpenSXPSite() {
    window.open(`https://investin.org/collections/summer-schools`);
  }

  return (
    <div>
      {/* W3 CSS */}
      <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css" />
      <link
        rel="stylesheet"
        href="https://www.w3schools.com/lib/w3-theme-black.css"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      <Header
        screenWidth={screenWidth}
        handleOpenOfficialWebsite={handleOpenOfficialWebsite}
        handleOpenBespokeForm={handleOpenBespokeForm}
      />
      <Stats screenWidth={screenWidth} />
      <OurTeam screenWidth={screenWidth} />
      <SpacesLeft screenWidth={screenWidth} />
      <SummerPricing
        screenWidth={screenWidth}
        handleOpenSXPSite={handleOpenSXPSite}
      />
      <ContactUs screenWidth={screenWidth} />
      <Footer />
    </div>
  );
};

export default HomePageConsultant;
